(function () {
  if (window.SorviqUGC) return;
  window.SorviqUGC = true;

  function sourceOf(video) {
    if (video.currentSrc) return video.currentSrc;
    var source = video.querySelector('source');
    return source ? source.src : video.src;
  }

  function closeModal(dialog) {
    var player = dialog.querySelector('video');
    player.pause();
    if (dialog.open) {
      if (dialog.close) dialog.close();
      else dialog.removeAttribute('open');
    }
  }

  document.addEventListener('click', function (e) {
    // Card click: open the same video full size, from the start, with sound.
    var card = e.target.closest('.sorviq-lp [data-ugc-open]');
    if (card) {
      var preview = card.querySelector('video');
      var dialog = card.closest('.sorviq-lp').querySelector('.ugc-modal');
      if (!preview || !dialog) return;
      var src = sourceOf(preview);
      if (!src) return;
      var player = dialog.querySelector('video');
      if (player.getAttribute('src') !== src) player.setAttribute('src', src);
      player.muted = false;
      player.currentTime = 0;
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');
      var playing = player.play();
      if (playing && playing.catch) playing.catch(function () {});
      return;
    }

    var closeBtn = e.target.closest('.sorviq-lp [data-ugc-close]');
    if (closeBtn) {
      closeModal(closeBtn.closest('.ugc-modal'));
      return;
    }

    // Click on the dark backdrop around the video closes it.
    if (e.target.classList && e.target.classList.contains('ugc-modal')) closeModal(e.target);
  });

  // Escape key closes the dialog natively: stop the sound too.
  document.addEventListener(
    'close',
    function (e) {
      if (e.target.classList && e.target.classList.contains('ugc-modal')) {
        e.target.querySelector('video').pause();
      }
    },
    true
  );
})();
